import { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import LinkIcon from '@mui/icons-material/Link';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  TwitterShareButton,
  XIcon
} from 'react-share';

import { shareSocialMedia } from 'store/course-actions';

import Message from '../Message/Message';

import classes from './ShareDegree.module.css';

const ShareDegree = props => {
  const [openMessage, setOpenMessage] = useState(false);
  const dataCourse = useSelector(state => state.courseInfo);

  const convertMSMonth = milliseconds => {
    let date = new Date(milliseconds);
    const month = date.getMonth();
    return month;
  };

  const convertMSYear = milliseconds => {
    let date = new Date(milliseconds);
    const year = date.getFullYear();
    return year;
  };

  const openLinkedin = () => {
    shareSocialMedia(
      props.urlCloudFront,
      props.ipAddress,
      'LinkedIn',
      window.location.toString()
    );
    const endDateMonth = convertMSMonth(props.endDate);
    const endDateYear = convertMSYear(props.endDate);
    window.open(
      `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${
        props.titleCourse
      }&organizationId=3114094&issueYear=${endDateYear}&issueMonth=${
        endDateMonth + 1
      }&certUrl=${dataCourse.userDegree.urlShare}`,
      '_blank'
    );
  };

  const handlerCopyDegree = () => {
    setOpenMessage(true);
    const copyText = document.getElementById('urlDegreeCopy');
    navigator.clipboard
      .writeText(copyText.value)
      .then(() => {
        console.log('Texto copiado al portapapeles');
      })
      .catch(err => {
        console.error('Error al copiar al portapapeles:', err);
      });
  };

  const handleCloseMessage = () => {
    setOpenMessage(false);
  };

  const trackDegreeHandler = socialMedia => () => {
    shareSocialMedia(
      props.urlCloudFront,
      props.ipAddress,
      socialMedia,
      window.location.toString()
    );
  };

  const twitterHashtags = ['Mayahii'];

  return (
    <div className={classes.shareContainer}>
      <p className={classes.title}>Compartir en:</p>
      <TwitterShareButton
        title={`Completé el curso ${props.titleCourse} en @MayahiiEdu. Ve mi diploma`}
        hashtags={twitterHashtags}
        url={dataCourse.userDegree.urlShare}
        className="Demo__some-network__share-button"
        onClick={trackDegreeHandler('twitter')}
      >
        <XIcon size={50} bgStyle={{ fill: '#464872' }} />
      </TwitterShareButton>
      <IconButton className={classes.copyBtn} onClick={openLinkedin}>
        <LinkedinIcon size={50} bgStyle={{ fill: '#464872' }} />
      </IconButton>
      <FacebookShareButton
        quote={`Completé el curso ${props.titleCourse} en Mayahii`}
        hashtag={`Completé el curso ${props.titleCourse} en Mayahii`}
        url={dataCourse.userDegree.urlShare}
        className="Demo__some-network__share-button"
        onClick={trackDegreeHandler('facebook')}
      >
        <FacebookIcon size={50} bgStyle={{ fill: '#464872' }} />
      </FacebookShareButton>
      <IconButton
        onClick={handlerCopyDegree}
        className={classes.copyBtn}
      >
        <LinkIcon className={classes.copyIcon} />
      </IconButton>

      <TextField
        disabled
        className={classes.inputUrlCopy}
        type="text"
        value={`${dataCourse.userDegree.urlShare}`}
        id="urlDegreeCopy"
      />
      {openMessage && (
        <Message
          openDialog={openMessage}
          closeDialog={handleCloseMessage}
          message="Enlace copiado"
          btnText="Aceptar"
        />
      )}
    </div>
  );
};

ShareDegree.propTypes = {
  // eslint-disable-next-line react/require-default-props
  urlViewPDF: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  titleCourse: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  endDate: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  URLShare: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  ipAddress: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  urlCloudFront: PropTypes.string
};

export default ShareDegree;
